import PlayListsView from './containers/PlayListViewContainer';

export default PlayListsView;